import React, {useEffect, useState} from 'react';
import {Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow} from "@material-ui/core";
import {getAnalysisModService, getAnalysisService} from "../../../services/app.service";
import {ANALYSIS_TYPES} from "../../../utils/constants";
import TextField from "@material-ui/core/TextField";
import Grid from "@material-ui/core/Grid";
import LoaderWithBackDrop from "../../../components/LoaderWithBackDrop/LoaderWithBackDrop.comp";

function Level7AlignmentComp(props) {

    const {application_id, reload} = props;

    const [analysis, setAnalysis] = useState({});
    const [loading, setLoading] = useState(false);

    async function fetchAnalysis() {
        try {
            setLoading(true);
            const result = await getAnalysisService(application_id, ANALYSIS_TYPES.LEVEL_7_ALIGNMENT);
            if(!result.error) {
                setAnalysis(result.data);
                console.log(result.data);
            }
            setLoading(false);
        }
        catch (e) {
            console.error(e);
            // already toasted the error
            setLoading(false);
        }
    }

    useEffect(() => {
        fetchAnalysis().then();
    }, [reload])

    return <>
        <TableContainer component={Paper}>
            <Table aria-label="simple table">
                <TableHead>
                    <TableRow>
                        <TableCell>Level 8</TableCell>
                        <TableCell>Aligned</TableCell>
                        <TableCell>Level 8 Full Name</TableCell>
                        <TableCell>Level 6</TableCell>
                        <TableCell>Level 6 Full Name</TableCell>
                        <TableCell>MB#</TableCell>
                        <TableCell>DQC#</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {
                        analysis.data && analysis.data.map((item) =>
                           <TableRow>
                               <TableCell>{item.level8}</TableCell>
                               <TableCell>{item.aligned ? 'Yes' : 'No'}</TableCell>
                               <TableCell>{item.level8_full_name}</TableCell>
                               <TableCell>{item.level6}</TableCell>
                               <TableCell>{item.level6_full_name}</TableCell>
                               <TableCell>{item.mb_no}</TableCell>
                               <TableCell>{item.dqc_no}</TableCell>
                           </TableRow>
                        )
                    }
                </TableBody>
            </Table>
            <LoaderWithBackDrop loading={loading}/>
        </TableContainer>
    </>
}

export default Level7AlignmentComp;